import { VideoThumbnail } from '#/components/VideoThumbnail/VideoThumbnail';
import { useI18n } from '#/i18n/hooks/useI18n';
import type {
  CmsApiSplitBlockAppearance,
  CmsApiSplitBlockVideo,
} from '#/modules/cms/api/types/blocks/CmsApiSplitContentBlock';
import { trackClicked } from '#/utils/analytics/track/trackClicked';
import { showModal } from '#/zustand-stores/modalStore';

import {
  CmsSplitContentVideoContent_Box_1,
  CmsSplitContentVideoContent_Box_2,
  CmsSplitContentVideoContentButton,
  CmsSplitContentVideoContentPlayButtonHolder,
} from './CmsSplitContentVideoContent.styled';

type Props = {
  appearance: CmsApiSplitBlockAppearance;
  blockId: string;
  blockIndex: number;
  index: number;
  preview: boolean;
  section: CmsApiSplitBlockVideo;
  desktopOnly?: boolean;
};

export function CmsSplitContentVideoContent({
  appearance,
  blockId,
  blockIndex,
  index,
  preview,
  section,
  desktopOnly,
}: Props) {
  const { i18n } = useI18n();

  const overlapping = appearance === 'OVERLAPPING';
  const fullWidth = appearance === 'FULL_WIDTH';

  const openVideo = () => {
    showModal('MEDIA_GALLERY', {
      items: [
        // @ts-expect-error TODO: fix types
        { type: 'VIDEO', videoUrl: section.data.url, autoPlay: true },
      ],
      itemIndex: 0,
      hideCaptionContainer: true,
    });
  };

  return (
    <CmsSplitContentVideoContent_Box_1
      data-qa-id={`split-content-section-${index}`}
      data-not-full-width={!fullWidth ? true : undefined}
      data-not-desktop-only={!desktopOnly ? true : undefined}
      key={blockId}
    >
      <CmsSplitContentVideoContent_Box_2
        data-overlapping={overlapping ? true : undefined}
        data-full-width={fullWidth ? true : undefined}
        data-full-width-and-not-preview={
          fullWidth && !preview ? true : undefined
        }
        data-overlapping-first={overlapping && index === 1 ? true : undefined}
      >
        <CmsSplitContentVideoContentButton
          aria-label={i18n('Open video')}
          $fullWidth={fullWidth}
        >
          <VideoThumbnail
            src={
              section.data.image
                ? { type: 'filestack', data: section.data.image }
                : { type: 'video-thumbnail', videoUrl: section.data.url }
            }
            onClick={() => {
              trackClicked('CMS Block', {
                block_position: blockIndex,
                block_type: 'Split Content',
                cta_type: 'Video',
              });
              openVideo();
            }}
            size={{ type: 'expand' }}
            eagerLoad={index < 2}
            playIcon={{
              size: 'large',
              // oxlint-disable-next-line react/no-unstable-nested-components
              render: (node) =>
                fullWidth ? (
                  <CmsSplitContentVideoContentPlayButtonHolder $index={index}>
                    {node}
                  </CmsSplitContentVideoContentPlayButtonHolder>
                ) : (
                  node
                ),
            }}
            qaId="split-block-video-image"
          />
        </CmsSplitContentVideoContentButton>
      </CmsSplitContentVideoContent_Box_2>
    </CmsSplitContentVideoContent_Box_1>
  );
}
